<template>
  <div
    v-if="isWishListItemPresent"
    class="wish-list-contents__from-wish-list-header"
  >
    <div class="wish-list-contents__title subhead-bold">
      ほしいものリストからギフトを選ぶ
    </div>
    <div class="wish-list-contents__explanation">
      お相手が登録しているほしいものの中からギフトを選んで贈れます
    </div>
  </div>
  <div v-else class="wish-list-contents__header--for-empty">
    <div class="wish-list-contents__title">
      <div class="wish-list-contents__title-nickname">
        {{ nickname }}
      </div>
      <div class="wish-list-contents__title-suffix subhead-bold">
        さんのほしいものリスト
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isWishListItemPresent: {
      type: Boolean,
      require: true,
      default: false
    },
    nickname: {
      type: String,
      require: false,
      default: ''
    }
  }
}
</script>
<style lang="scss" scoped>
.wish-list-contents {
  &__header {
    &--for-empty {
      max-width: $small-contents-width;
      margin: 0 auto 16px;
      padding: 24px 16px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

  &__from-wish-list-header {
    max-width: $small-contents-width;
    margin: 0 auto 24px;
    padding: 24px 16px 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  &__title {
    display: flex;
    align-items: center;
    flex: 1;
    min-width: 0;
  }

  &__title-nickname {
    @extend %subhead-bold;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__title-suffix {
    white-space: nowrap;
  }

  &__explanation {
    @extend %caption;
    margin: 8 auto 24 auto;
    text-align: left;
  }
}
</style>
